import { Flex, Button, Radio, Space, Text } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import classes from './Radio.module.css';
import { useState } from 'react';
import { observer } from 'mobx-react';
import { MyIcon } from '../MyIcon';
import { BaseModal } from '../BaseModal';
import { i18n } from 'i18next';

const availableLanguages = [
  {
    language: 'de',
    label: 'Deutsch',
  },
  {
    language: 'en',
    label: 'English',
  },
];

export const LanguagePicker = observer(
  ({
    currentLang,
    onSave,
    t,
    i18n,
  }: {
    currentLang?: 'de' | 'en';
    onSave?: (lang: 'de' | 'en') => void;
    t: (key: string) => string;
    i18n: i18n;
  }) => {
    const [opened, { toggle, close }] = useDisclosure(false);
    const [value, setValue] = useState(
      currentLang || i18n.language?.toLocaleLowerCase?.() || 'de',
    );

    const changeLanguage = () => {
      void i18n.changeLanguage(value);
      onSave?.(value as 'de' | 'en');
      close();
    };

    return (
      <>
        <Flex p="0px 10px" gap="5px" onClick={toggle}>
          <Text size="14px" lh="25px" fw="500">
            {value?.toLocaleUpperCase?.()}
          </Text>
          <MyIcon name="language" />
        </Flex>

        <BaseModal
          opened={opened}
          onClose={close}
          title=""
          size="500px"
          description={
            <Flex direction="column">
              <Text size="21px" lh="24px" fw="600" c="#202020">
                {t('LanguagePicker.Title')}
              </Text>
              <Radio.Group
                value={value}
                onChange={(value) => setValue(value as string)}
                name="LanguagePicker"
                w="100%"
              >
                {availableLanguages.map((language) => (
                  <Radio
                    classNames={classes}
                    key={language.language}
                    value={language.language}
                    label={language.label}
                  />
                ))}
              </Radio.Group>
              <Space h="40px" />

              <Button key="submit" onClick={changeLanguage} w="100%">
                {t('Buttons.Save')}
              </Button>
            </Flex>
          }
          iconColor="#202020"
        />
      </>
    );
  },
);
